export enum AgentInteractionStatus {
	NotApplicable = -2,
	Unknown = -1,
	Offering = 0,
	Active = 1, //e.g. outbound target
	Terminated = 2,
	Rejected = 3,
	WarmTransferInviteSent = 4, //Agent 1
	WarmTransferInviteAccepted = 5, //Agent 1
	WarmTransferInviteRejected = 6, //Agent 1
	WarmTransferConsultingCaller = 7, //Agent 1
	WarmTransferConsultingAgent = 8, //Agent 1
	ReceivingWarmTransferInvitation = 9, //Agent 2
	AcceptedWarmTransferInvitation = 10, //Agent 2
	WarmCanceled = 11, //Agent 1
	WarmCanceledBySecondAgent = 12, //Agent 1
	CalleeUnavailable = 13, //Agent 1
	Paused = 14,
	Resumed = 15,
	Parked = 16,
	MonitoringStarting = 17,
	Monitoring = 18,
	MonitoringEnded = 19,
	CallbackRegistered = 20,
	SimultaneousOffering = 21,
	SimultaneousOfferingTerminated = 22,
	SimultaneousOfferingCallerLeft = 23,
	SimultaneousOfferingIgnored = 24,
	InitiatedWarmTransferConferenceMode = 25,
	PartOfWarmTransferConferenceMode = 26,
	OutboundAcceptedByAgent = 27, //Agent 1
}

export enum CallState {
	None = 'None',
	Connecting = 'Connecting',
	Connected = 'Connected',
	Ringing = 'Ringing',
	LocalHold = 'LocalHold',
	RemoteHold = 'RemoteHold',
	InLobby = 'InLobby',
	Disconnecting = 'Disconnecting',
	Disconnected = 'Disconnected',
	EarlyMedia = 'EarlyMedia',
}
